import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOnboarding } from '../hooks/useOnboarding';

const OnboardingTrigger: React.FC = () => {
  const location = useLocation();
  const { checkReportsViewed } = useOnboarding();

  useEffect(() => {
    // Auto-complete steps based on route visits
    if (location.pathname === '/reports') {
      checkReportsViewed();
    }
  }, [location.pathname, checkReportsViewed]);

  return null; // This component doesn't render anything
};

export default OnboardingTrigger;